import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators'; // Usa gli operatori corretti di RxJS
import { environment } from './../../../../environments/environment';
import { CostItemProduct } from './../../_models/financials/costItemProduct';

@Injectable()
export class CostItemProductsService {
  private apiBaseUrl = environment.apiBaseUrl;

  constructor(private http: HttpClient) {}

  getList(): Observable<CostItemProduct[]> {
    return this.http.get<CostItemProduct[]>(
      `${this.apiBaseUrl}api/private/v1/financial/costItemProducts`
    );
  }

  get(id: number): Observable<CostItemProduct> {
    return this.http.get<CostItemProduct>(
      `${this.apiBaseUrl}api/private/v1/financial/costItemProducts/${id}`
    );
  }

  save(costItemProductItem: CostItemProduct): Observable<CostItemProduct> {
    const costItemProduct = { ...costItemProductItem };
    // Rimuovi campi non necessari
    delete costItemProduct.lastUpdated;
    delete costItemProduct.dateCreated;

    // Aggiungi il companyId se esiste
    const companySelected = JSON.parse(localStorage.getItem('companySelected'));
    costItemProduct.companyId = companySelected ? companySelected.id : null;

    // Se l'oggetto ha un id, effettua un PUT, altrimenti un POST
    if (costItemProduct.id) {
      return this.http.put<CostItemProduct>(
        `${this.apiBaseUrl}api/private/v1/financial/costItemProducts/${costItemProduct.id}`,
        costItemProduct
      );
    } else {
      return this.http.post<CostItemProduct>(
        `${this.apiBaseUrl}api/private/v1/financial/costItemProducts/`,
        costItemProduct
      );
    }
  }

  delete(costItemProduct: CostItemProduct): Observable<CostItemProduct> {
    return this.http
      .delete<void>(
        `${this.apiBaseUrl}api/private/v1/financial/costItemProducts/${costItemProduct.id}`
      )
      .pipe(
        map(() => {
          return { id: costItemProduct.id } as CostItemProduct;
        })
      );
  }
}
